/**
 * Pure helpers for BioUpdatesPanel.
 * Extracted so they can be unit-tested without dragging the whole panel
 * (and its lucide-react / axios imports) through Jest.
 */

export function firstName(full) {
  if (!full) return null;
  const trimmed = String(full).trim();
  if (!trimmed) return null;
  return trimmed.split(/\s+/)[0];
}

/**
 * Merge a current bio value with a proposed supersede value, used by the
 * "Append" action on textarea / multi_select fields.
 *
 * - multi_select: case-insensitive union, preserves order (current first),
 *   clamped to `maxSelections` when provided.
 * - textarea: smart concat with "; " or "\n" separator. Skips append if
 *   the proposed text is already a substring of the current (case-insensitive).
 */
export function appendMerge({ current, proposed, fieldType, maxSelections }) {
  if (fieldType === "multi_select") {
    const cur = Array.isArray(current) ? current : [];
    const prop = Array.isArray(proposed) ? proposed : [];
    const merged = [];
    const seen = new Set();
    for (const v of [...cur, ...prop]) {
      const key = String(v).trim().toLowerCase();
      if (key && !seen.has(key)) {
        seen.add(key);
        merged.push(v);
      }
    }
    return maxSelections ? merged.slice(0, maxSelections) : merged;
  }
  // textarea
  const cur = (current == null ? "" : String(current)).trim();
  const prop = (proposed == null ? "" : String(proposed)).trim();
  if (!cur) return prop;
  if (!prop) return cur;
  if (cur.toLowerCase().includes(prop.toLowerCase())) return cur;
  // Use newline separator if either side already has one, else "; ".
  const sep = cur.includes("\n") || prop.includes("\n") ? "\n" : "; ";
  return `${cur}${sep}${prop}`;
}
